import { useEffect, useState } from "react";
import { authHeader } from "../auth";

// Config d'habillage papier (titre course, logos, pied de page) PAR
// CATÉGORIE — chaque course parallèle (women1, men1...) a la sienne.
export function useParallelBranding(category) {
    const [branding, setBranding] = useState({});

    useEffect(() => {
        if (!category) {
            setBranding({});
            return;
        }
        fetch(`/api/parallel-branding/${encodeURIComponent(category)}`, {
            headers: { ...authHeader() },
        })
            .then((r) => (r.ok ? r.json() : {}))
            .then((data) => setBranding(data || {}))
            .catch(() => setBranding({}));
    }, [category]);

    return branding;
}